import { WorkflowStepCode } from '@exam-management/graphql';

import { QSetReviewWorkflowStepCodeObject } from './types';

export const mappedQSetReviewSubtaskStatus = {
  [WorkflowStepCode.ReviewQsetTodo]: QSetReviewWorkflowStepCodeObject.QsetReviewTodo,
  [WorkflowStepCode.ReviewQsetInReview]: QSetReviewWorkflowStepCodeObject.QsetReviewInReview,
  [WorkflowStepCode.ReviewQsetReviewed]: QSetReviewWorkflowStepCodeObject.QsetReviewReviewed,
  [WorkflowStepCode.ReviewQsetDone]: QSetReviewWorkflowStepCodeObject.QsetReviewDone,
};
